export default __webpack_public_path__ + "static/data-officer-b1d95127de3dc3ba884bfdbecd434237.jpg";